let promptHost = null

export function registerAppPromptHost(vm) {
  promptHost = vm
}

export function getAppPromptHost() {
  return promptHost
}
